const baseUrl = `${window.location.origin}/portals/`;

export const getBrandPortalUrlFromSlug = (slug?: string) => {
	if (!slug) return baseUrl;
	return `${baseUrl}${slug}`;
};
